import { render, staticRenderFns } from "./card-base.vue?vue&type=template&id=332e810c&scoped=true"
import script from "./card-base.vue?vue&type=script&lang=js"
export * from "./card-base.vue?vue&type=script&lang=js"
import style0 from "./card-base.vue?vue&type=style&index=0&id=332e810c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e810c",
  null
  
)

export default component.exports